import React from 'react';
import styled from 'styled-components';

const AvatarContainer = styled.div`
  width: ${props => props.size || 40}px;
  height: ${props => props.size || 40}px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: ${props => (props.size ? props.size / 2.5 : 16)}px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

function Avatar({ name, imageUrl, size }) {
  const initials = name
    ? name
        .split(' ')
        .map(part => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '?';

  return (
    <AvatarContainer size={size}>
      {imageUrl ? <img src={imageUrl} alt={name || 'User avatar'} /> : initials}
    </AvatarContainer>
  );
}

export default Avatar;